import { RootState } from '@/index';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CLSTAG, CockpitMode, IssueStatus, IssueType } from '@/utils/constant';
import classNames from 'classnames';
import DiscardIssueModal from '@/components/DiscardIssueModal';
import { clstagStr } from '@/utils/util';
const DiscardIssue = (props: {
  vehicleName: string;
  disabled: boolean;
  closeDropdown: () => void;
}) => {
  const [open, setOpen] = useState(false);
  const { vehicleName, disabled, closeDropdown } = props;
  const { cockpitMode } = useSelector((state: RootState) => state.cockpitInfo);
  const { issueList } = useSelector((state: RootState) => state.workOrder);
  const issueInfo =
    issueList &&
    issueList.find((workOrder: any) => {
      return (
        workOrder.vehicleName === vehicleName &&
        workOrder.issueType === IssueType.OPS
      );
    });
  const usable =
    (issueInfo?.issueStatus === IssueStatus.PROCESS ||
      issueInfo?.issueStatus === IssueStatus.ON_HOLD) &&
    cockpitMode !== CockpitMode.MONITOR &&
    !disabled &&
    issueInfo?.issueType !== IssueType.PROBLEM_REPORT;

  return (
    <>
      <button
        className="issue-command-btn"
        disabled={!usable}
        onClick={() => {
          usable && setOpen(true);
          props.closeDropdown();
        }}
        clstag={clstagStr(CLSTAG.DiscardIssue)}
      >
        抛单
      </button>

      <DiscardIssueModal
        open={open}
        setOpen={setOpen}
        vehicleName={vehicleName}
      />
    </>
  );
};
export default React.memo(DiscardIssue);
